<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="clientAffecterForm" @submit="addClientAffecter" :validation-schema="clientAffecterSchema">
        <div class="row">
          <div class="col-md-12 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Utilisateur <span class="text-danger">*</span>
              </label>
              <Field name="user" v-slot="{ field }">
                <Multiselect v-model="field.value" :options="userOptions" :searchable="true" track-by="label"
                  label="label" placeholder="Sélectionner l'Utilisateur" v-bind="field" />
              </Field>
              <ErrorMessage name="user" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Client <span class="text-danger">*</span>
              </label>
              <Field name="client" v-slot="{ field }">
                <Multiselect v-model="field.value" :options="clientOptions" :searchable="true" track-by="label" mode="tags"
                  label="label" placeholder="Sélectionner le Client" v-bind="field" />
              </Field>
              <ErrorMessage name="client" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button class="btn btn-success me-3" type="submit">
                Ajouter une affectation
              </button>
              <router-link to="/clientAffecter/liste-clientAffecter" class="btn btn-danger">
                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative">Annuler</span>
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import { success, error } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect';
import { ClientAffecter } from '@/models/ClientAffecter';

export default defineComponent({
  name: "AddClientAffecter",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup: () => {
    const clientAffecterSchema = Yup.object().shape({
      user: Yup.string().required("L'utilisateur est obligatoire"),
      client: Yup.array().required("Le client est obligatoire"),
    });

    const clientAffecterForm = ref(null);
    const router = useRouter();
    const clientOptions = ref([]);
    const userOptions = ref([]);
    const isUPDATE = ref(false);
    const user = ref();
    const client = ref();

    const title = ref("Ajouter une affectation client");
    const btntext = ref('Ajouter');

    const btnTitle = async () => {
      if (isUPDATE.value) {
        title.value = "Modifier l'affectation client";
        btntext.value = "Modifier";
      } else {
        title.value = "Ajouter une affectation client";
        btntext.value = "Ajouter";
      }
    };

    const getAllClients = async () => {
      try {
        const response = await ApiService.get('/all/clients');
        const clientData = response.data.data;
        clientOptions.value = clientData.map((client: any) => ({
          value: client.id,
          label: client.nomClient && client.prenomClient
            ? `${client.nomClient} ${client.prenomClient}`
            : `${client.raisonSociale}`,
        }));
      } catch (err) {
      //
      }
    };

    const getAllUsers = async () => {
      try {
        const response = await ApiService.get('/all/users');
        const userData = response.data.data;
        userOptions.value = userData.map((user: any) => ({
          value: user.id,
          label: `${user.nom} ${user.prenom}`,
        }));
      } catch (err) {
        //error('Erreur lors de la récupération des utilisateurs');
      }
    };

    const addClientAffecter = async (values: any, { resetForm }: any) => {
      values = values as ClientAffecter;
      try {
        const { data } = await ApiService.post('/clientAffecter', values);
        if (data.code === 201) {
          success(data.message);
          resetForm();
          router.push({ name: "ListeClientAffecter" });
        }
      } catch (err: any) {
        error(err.response?.data?.message || 'Erreur lors de l\'ajout de l\'affectation');
      }
    };

    const resetValue = () => {
      isUPDATE.value = false;
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      formFields.forEach(field => (field.value = ''));
      btnTitle();
    };

    onMounted(async () => {
      await Promise.all([getAllClients(), getAllUsers()]);
    });

    return {
      clientAffecterSchema,
      clientAffecterForm,
      addClientAffecter,
      title,
      btntext,
      resetValue,
      clientOptions,user, client,
      userOptions,
    };
  },
});
</script>